module.exports = __webpack_public_path__ + "img/shop-unchecked.da54859c.svg";